import { Injectable, Inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Rx'
import { APP_CONFIG, IAppConfig } from '../../app.config'
import { Helpers } from './helpers'
import { Base } from '../base'
import { JwtHelper } from './jwt-helper'
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class TokenBase extends Base {
    public expiresIn: number;
    public authTime: number;

    /**
        Scheduling of the refresh token.
    */
    public refreshSubscription: any; 

    /**
    * Stores the URL so we can redirect after signing in.
    */
    public redirectUrl: string | null;

    /**
     * Behavior subjects of the user's status, data & roles.
     */
    public signinSubject = new BehaviorSubject<boolean>(this.tokenNotExpired());

    constructor(public http: HttpClient, @Inject(APP_CONFIG) public config: IAppConfig, public permissionsService: NgxPermissionsService) {
        super();
    }    

    public encodeParams(params: any): string {
        let body: string = "";
        for (const key in params) {
            if (body.length) {
                body += "&";
            }
            body += key + "=";
            body += encodeURIComponent(params[key]);
        }
        return body;
    }

    public store(body: any): void {
        if (typeof body.accessToken !== 'undefined') {          

            Helpers.setSessionStorage('id_token', body.accessToken);
            Helpers.setSessionStorage('refresh_token', body.refreshToken);

            this.userInfo(body.accessToken);

            // Calculates token expiration.
            Helpers.setExp(body.expiresIn as number * 1000);
        }        
    }

    public userInfo(token: any): void {
        let jwtHelper = new JwtHelper();
        let decodedIdToken = jwtHelper.decodeToken(token);

        let userPermissions: Array<string> = [];

        if (decodedIdToken.permission) {
            if (decodedIdToken.permission.constructor != Array) {
                userPermissions.push(decodedIdToken.permission);
                // Store permissions in Permission Service
                this.permissionsService.loadPermissions(userPermissions);
            }
            else {
                // Store permissions in Permission Service
                this.permissionsService.loadPermissions(decodedIdToken.permission);
            }
        }
    }

    /**
     * Checks for presence of token and that token hasn't expired.
     */
    public tokenNotExpired(): boolean {
        const token: string | null = Helpers.getSessionStorage('id_token');
        return token != null && (Helpers.getExp() > new Date().valueOf());
    }

    /**
     * Revokes token.
     */
    public revokeToken(): void {
        Helpers.removeSessionStorage('id_token');
        Helpers.removeSessionStorage('logged_in_user');
        Helpers.removeExp();
    }

    /**
     * Revoke Refresh Token
     */
    public revokeRefreshToken(): void {
        let refreshToken: string| null = Helpers.getSessionStorage('refresh_token');    
        let path = this.config.apiEndpoint + "RefreshToken";

        if (refreshToken != null && refreshToken !== '') {
            let request: any = {
                refreshToken: refreshToken
            };

            this.http.put(path, request)
                .subscribe(
                    () => {
                        Helpers.removeSessionStorage('refresh_token');
                    });
        }
    }

    /**
     * Unsubscribes from the scheduling of the refresh token.
     */
    public unscheduleRefresh(): void {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    public getLoggedInUserID(): string {
        const token: string | null = Helpers.getSessionStorage('id_token');

        if (token) {
            let jwtHelper = new JwtHelper();
            let decodedIdToken = jwtHelper.decodeToken(token);
            return decodedIdToken.Id;
        }

        return "";        
    }
}